import React from 'react';
import { ButtonLink } from './ButtonLink';
import { Reveal } from './Reveal';
interface CtaBandProps {
  title?: string;
  lead?: string;
}
export function CtaBand({
  title = 'Your next leadership decision deserves a considered partner.',
  lead = 'Whether you are building a leadership team or exploring your next role, start with a confidential conversation.'
}: CtaBandProps) {
  return <section className="bg-midnight-900 text-champagne-50" data-id="element-30" data-mp="rfuvky5jwbhz">
      <Reveal className="mx-auto flex max-w-site flex-col gap-10 px-6 py-20 lg:flex-row lg:items-end lg:justify-between lg:px-10 lg:py-28" data-id="element-31" data-mp="rd8kwpnd5fvj">
        <div className="max-w-2xl" data-id="element-32" data-mp="107d8n077ab6u">
          <h2 className="font-serif text-4xl leading-tight md:text-5xl" data-id="element-33" data-mp="1086gy5lt58r3">{title}</h2>
          <p className="mt-5 text-lg text-champagne-100/70" data-id="element-34" data-mp="155esvogd4gjw">{lead}</p>
        </div>
        <div className="flex flex-wrap gap-4" data-id="element-35" data-mp="1a6m2lt22fpt7">
          <ButtonLink to="/contact?type=employer" withArrow data-id="element-36" data-mp="1a3q3w2ie8x3p">
            Discuss Your Hiring Needs
          </ButtonLink>
          <ButtonLink to="/contact?type=candidate" variant="outlineDark" data-id="element-37" data-mp="1z73kcltuxtso">
            Introduce Yourself
          </ButtonLink>
        </div>
      </Reveal>
    </section>;
}